import { Injectable } from '@angular/core';
import { TranslocoService, } from '@jsverse/transloco';

const AVAILABLE_LANGS = ['en', 'es', 'fr', 'ja'];

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(private readonly translocoService: TranslocoService) { }

  switchLanguage(language: string) {
    const lang = AVAILABLE_LANGS.includes(language) ? language : 'en';
    this.translocoService.setActiveLang(lang);
    localStorage.setItem('selectedLanguage', lang);
  }
}